import * as React from 'react';

export interface PaletteProps {
  dataHook?: string;
  fill?: React.ReactNode[];
}

export default class Palette extends React.PureComponent<PaletteProps> {}
